import {
  Compatibility,
  type CompatibilityType,
} from '@/components/TypesenseFilters/types';

export const getCompatibilityVersionText = (
  compatibility: CompatibilityType,
  isSmallScreen?: boolean
) => {
  const map = {
    [Compatibility.MOGRT]: 'Adobe CC 2022+',
    [Compatibility.PremierePro]: 'Adobe CC 2022+',
    [Compatibility.AfterEffects]: 'Adobe CC 2022+',
    [Compatibility.DragAndDrop]: isSmallScreen
      ? 'For any software'
      : 'For all major editing software',
    [Compatibility.DaVinciResolve]: 'Resolve 18',
  };

  if (compatibility in map) {
    return map[compatibility as keyof typeof map];
  }

  return null;
};
